const el = $('#create-order-for-whatsapp-only');

if (el.length) {
    const el_payment_form = $('.payment-form'),
        el_submit_button = el_payment_form.find('[type=submit]');
    el_payment_form.on('submit', function (e) {
        e.preventDefault();

        App.prototype.loadingButton(el_submit_button, 0);

        App.prototype.manuallySetIntlTelInputValueForAjax();

        var formData = el_payment_form.serialize();
        $.ajax({
            type: 'POST',
            url: el_payment_form.attr('action'),
            dataType: "json",
            data: formData,
            success: function (response) {
                const clean_whatsapp = /[\D]+/g,
                    new_url = "https://wa.me/" + response.shop.whatsapp_phone.replace(clean_whatsapp, '');

                el_payment_form.find('[name="text"]').val(response.order_whatsapp_message)

                el_payment_form.find('[name!="text"]').removeAttr('name');

                el_payment_form.attr('action', new_url);
                el_payment_form.attr('method', 'GET');

                el_payment_form.off('submit').submit();

            },
            error: function () {
                App.prototype.notificationError("Sipariş esnasında bir hata oluştu lütfen sayfayı yenileyip tekrar deneyiniz.");
            },
            complete: function () {
                App.prototype.loadingButton(el_submit_button, 1);
            }
        });
    })

}
